import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { chat_list, ChatFiltersCount, get_chat_users, GetChatMembers, getChatRequest } from '../../Apis';


export const getChatList = createAsyncThunk('get Chat list', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await chat_list(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetChatUsers = createAsyncThunk('GetChatUsers', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_chat_users(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const getChatCountFilters = createAsyncThunk("getChatCountFilter", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await ChatFiltersCount(token, formData);
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const getAddMembersList = createAsyncThunk("getChatAddMember", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await GetChatMembers(token, formData)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const GetChatRequest = createAsyncThunk("get-chat-request", async ({ token, _ }, { rejectWithValue }) => {
    try {
        const response = await getChatRequest(token);
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})







const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        error: null,
        success: false,
        data: [],
        chatList: [],
        url: "",
        chat_id: "",
        usersList: [],
        chatFilters: {},
        chatAddMember: [],
        membersLoading: false,
        chatRequest: [],
        activeChatId: null,
        removedUserIds: null,
        IsremovedUser: false



    },


    // reducers: {


    //     clearChatStatus: state => {
    //         state.success = false;
    //         state.error = null;
    //     },
    //     clearurl: state => {
    //         state.url = "";

    //     },
    //     // setActiveChat: (state, action) => {
    //     //     state.activeChatId = action.payload;
    //     //     state.data = [];
    //     // },
    //     activeChatId: null,
    //     clearActiveChat: (state) => {
    //         state.activeChatId = null;
    //     },



    // },
    reducers: {
        clearChatStatus: state => {
            state.success = false;
            state.error = null;
        },
        clearurl: state => {
            state.url = "";

        },
        clearChatState: (state) => {
            state.chat_id = null;
            state.activeChatId = null;
            state.data = [];
        },

        setActiveChat: (state, action) => {
            console.log("show active chat id from --->", action.payload);

            state.activeChatId = action.payload;
            state.data = [];   // clear previous chat messages
        },

        // setChatMessage: (state, action) => {
        //     st

        // setActiveChat: (state, action) => {
        //     console.log("show actoione from payload---->", action.payload);

        //     state.data = [...state.data, action.payload];
        //     // },
        //     if (state.activeChatId !== action.payload) {
        //         state.data = [];
        //     }

        //     state.activeChatId = action.payload;
        //     console.log("show activeChatId action payload from redux ----->", state.activeChatId);

        //     // console.log("show active chatid from redux slice---->", state.activeChatId);

        // },

        // setChatMessage: (state, action) => {
        //     const newMsg = action.payload;
        //     console.log("CONSOLE FROM REDUX STATE", state?.data);
        //     state.activeChatId = newMsg?.chat_id

        //     console.log("CONSOLE FROM REDUX NEWMSG-->", newMsg);


        //     // 1️ If message has DB id → use id (best unique key)
        //     if (newMsg.id) {
        //         const exists = state.data.some(m => m.id === newMsg.id);
        //         if (!exists) {
        //             state.data.push(newMsg);
        //         }
        //         return;
        //     }

        //     // allback (for messages without id)  
        //     const exists = state.data.some(m =>
        //         m.from_user_id === newMsg.from_user_id &&
        //         m.to_user_id === newMsg.to_user_id &&
        //         m.message === newMsg.message &&
        //         // Math.abs(new Date(m.timestamp) - new Date(newMsg.timestamp)) < 5000
        //         Math.abs(new Date(m.created_at) - new Date(newMsg.created_at)) < 5000
        //     );

        //     if (!exists) {
        //         state.data.push(newMsg);
        //     }
        // },



        setChatMessage: (state, action) => {
            console.log("show chatId from redux in sendMessage 1 -->", state.chat_id);
            console.log("show chatId from redux in sendMessage 2 -->", state.activeChatId);
            console.log("show chatId from redux in sendMessage 3-->", action.payload);
            // console.log("show chatId from redux in sendMessage-->", state.activeChatId);  


            const newMsg = action.payload;
            // if (newMsg.chat_id === state.activeChatId ?? state.chat_id &&
            //     newMsg.status === "removed" &&
            //     newMsg.to_user_id === auth?.userid


            // ) {
            //     IsremovedUser(true)
            // }

            if (newMsg.id) {
                // console.log("checknewmsgs==raje", newMsg)
                const exists = state.data.some(m => m.id === newMsg.id);
                if (!exists) {
                    // state.data.push(newMsg);   //  correct for ASC
                    state.data = [newMsg, ...state.data];
                }
                return;
            }


            const exists = state.data.some(m =>
                m.from_user_id === newMsg.from_user_id &&
                m.to_user_id === newMsg.to_user_id &&
                m.message === newMsg.message
            );

            if (!exists) {
                // state.data.push(newMsg);
                // console.log("checknewmsgs==else", newMsg)  

                state.data = [newMsg, ...state.data];
                // state.data = [...state.data, newMsg];

            }
        },

        // setOlderMesage: (state, action) => {
        //     action.payload.forEach(element => {
        //         state.data = [element, ...state.data];
        //     });
        // },





        setOlderMesage: (state, action) => {
            // state.data = [...action.payload, ...state.data];
            state.data = [...state.data, ...action.payload];
        },
        msg_status_update: (state, action) => {
            state.data.forEach(element => {
                if (element.id == action.payload.id) {
                    element.status = action.payload.status;
                }
            });
        },
        sent_status_update: (state, action) => {
            state.data.forEach(element => {
                if (element.status === "timer") {
                    element.id = action.payload.id;
                    element.status = action.payload.status;
                }
            });
        },
        setChatUser: (state, action) => {
            const incomingMsg = action.payload;

            // Find existing user by matching `connection_id`
            const existingIndex = state.usersList.findIndex(
                user => user.connection_id === incomingMsg.connection_id
            );

            if (existingIndex !== -1) {
                // Update existing user entry
                state.usersList[existingIndex] = {
                    ...state.usersList[existingIndex],
                    message: incomingMsg.message,
                    status: incomingMsg.status,
                    created_at: incomingMsg.created_at,
                    user_status: incomingMsg.user_status || state.usersList[existingIndex].user_status
                };

                // Move updated user to top
                const updatedUser = state.usersList.splice(existingIndex, 1)[0];
                state.usersList.unshift(updatedUser);
            } else {
                // If not found, push new user (you may want to adjust this shape as needed)
                state.usersList.unshift({
                    id: incomingMsg.id,
                    product_id: incomingMsg.product_id,
                    chat_type: incomingMsg.chat_type,
                    project_title: incomingMsg.project_title,
                    connection_id: incomingMsg.connection_id,
                    email: incomingMsg.email,
                    first_name: incomingMsg.first_name,
                    last_name: incomingMsg.last_name,
                    image: incomingMsg.image,
                    message: incomingMsg.message,
                    status: incomingMsg.status,
                    created_at: incomingMsg.created_at,
                    user_status: incomingMsg.user_status
                });
            }
        }


    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(getChatList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(getChatList.fulfilled, (state, action) => {
                state.data = action.payload.data.data;
                state.chat_id = action.payload.data.chat_id;
                // state.chat_id = 777;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(getChatList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetChatUsers.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetChatUsers.fulfilled, (state, action) => {
                state.chatList = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetChatUsers.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(getChatCountFilters.pending, (state, action) => {
                state.error = null;
                state.success = false;

            })
            .addCase(getChatCountFilters.fulfilled, (state, action) => {
                state.error = null;
                state.chatFilters = action.payload.data.data;
                state.success = true
            })
            .addCase(getChatCountFilters.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false
            })
            .addCase(getAddMembersList.pending, state => {
                state.success = false;
                state.error = null;
                state.membersLoading = true;
            })
            .addCase(getAddMembersList.fulfilled, (state, action) => {
                state.error = null;
                state.success = true;
                state.membersLoading = false
                state.chatAddMember = action.payload.data
            })
            .addCase(getAddMembersList.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;
                state.membersLoading = false
            })
            .addCase(GetChatRequest.pending, state => {
                state.success = false;
                state.error = null;
                state.membersLoading = true;
            })
            .addCase(GetChatRequest.fulfilled, (state, action) => {
                state.error = null;
                state.success = true;
                state.membersLoading = false
                state.chatRequest = action.payload.data
            })
            .addCase(GetChatRequest.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;
                state.membersLoading = false
            })
    },

});
export const { clearChatStatus, clearActiveChat, setChatMessage, clearChatState, setActiveChat, clearurl, setOlderMesage, msg_status_update, sent_status_update, setChatUser } = chatSlice.actions;
export default chatSlice.reducer;

